import { useState } from 'react';

import { useMsal } from '@azure/msal-react';
import { notification } from 'antd';

import { OrderReason } from '../../../../../../../api-client';
import { OrderApiClient } from '../../../../../../../providers/api-provider';

export const useCompleteDialog = () => {
	const { instance } = useMsal();

	const [orderReasons, setOrderReasons] = useState<OrderReason[]>();
	const [orderReasonsLoading, setOrderReasonsLoading] =
		useState<boolean>(false);

	const handleOrderReasons = async () => {
		setOrderReasonsLoading(true);

		const clientApi = await OrderApiClient(instance);

		clientApi
			.getOrderReasons()
			.then((response) => {
				setOrderReasons(response.data);
			})
			.catch((reason) => {
				setOrderReasons([]);

				notification.error({
					message: 'Unable to retrieve order reasons!',
					description: 'Unable to retrieve the order reasons.',
					duration: 2,
				});
			})
			.finally(() => {
				setOrderReasonsLoading(false);
			});
	};

	return {
		handleOrderReasons,
		orderReasons,
		orderReasonsLoading,
	};
};
